(ns app.ui.reports.common
  "Functions and data common to both computing and displaying a
  report.")

(def ^:const purchased-product-group-bys #{"purchasedProductSkuId" "purchasedProductMainCategoryId" "purchasedProductBrandId" "purchasedProductBrandName" "purchasedProductMerchantId"})
(def ^:const promoted-product-group-bys #{"promotedProductSkuId" "promotedProductMainCategoryId" "promotedProductBrandId" "promotedProductBrandName" "promotedProductMerchantId"})

;; TODO: I'd like to refactor this so that stuff specific to
;; formatting goes into the .cljs, and stuff specific to
;; computation goes into the worker. For now they're together, and
;; that's okay.

;; Fields related to "Device" object in reporting, keeping names consistent with upstream services
(def device-fields
  {"brandname"           "brandname"
   "modelname"           "modelname"
   "advertisedos"        "advertisedos"
   "osmajorversion"      "osmajorversion"
   "osminorversion"      "osminorversion"
   "browser"             "browser"
   "browsermajorversion" "browsermajorversion"
   "browserminorversion" "browserminorversion"
   "formfactor"          "formfactor"})

;; Fields related to "Bid modifier" object in reporting, keeping names consistent with upstream services
(def bid-modifier-fields
  {"bidmodifiertype"       "bidmodifiertype"
   "bidmodifiervalue"      "bidmodifiervalue"
   "bidmodifiermultiplier" "bidmodifiermultiplier"
   "bidmodifierprice"      "bidmodifierprice"})

(def purchased-product-subtotal-fields
  ["purchasedproductskuid"
   "purchasedproductskuname"
   "purchasedproductmaincategoryid"
   "purchasedproductmaincategoryname"
   "purchasedproductbrandid"
   "purchasedproductbrandname"
   "purchasedproductmerchantid"
   "purchasedproductmerchantname"])

(def product-fields
  {;; DEPRECATED
   "productskuid"            "productskuname"
   "productmaincategoryid"   "productmaincategoryname"
   "productbrandid"          "productbrandname"
   "productmerchantid"       "productmerchantname"

   ;; New disambiguated
   ;; Promoted
   "promotedproductskuid"            "promotedproductskuname"
   "promotedproductmaincategoryid"   "promotedproductmaincategoryname"
   "promotedproductbrandid"          "promotedproductbrandname"
   "promotedproductmerchantid"       "promotedproductmerchantname"
   ;; Purchased
   "purchasedproductskuid"            "purchasedproductskuname"
   "purchasedproductmaincategoryid"   "purchasedproductmaincategoryname"
   "purchasedproductbrandid"          "purchasedproductbrandname"
   "purchasedproductmerchantid"       "purchasedproductmerchantname"
})

(def report-name-fields-order
  "Maps from the value to the name fields in the report CSV."
  (merge {"adtypeid"          "adtypename"
          "advertiserid"      "advertisername"
          "campaignid"        "campaignname"
          "channelid"         "channelname"
          "countrycode"       "countrycode"
          "regioncode"        "regioncode"
          "creativeid"        "creativename"
          "flightid"          "flightname"
          "adid"              "adname"
          "keyword"           "keyword"
          "metrocode"         "metroname"
          "price"             "price"
          "priorityid"        "priorityname"
          "siteid"            "sitename"
          "placementcategory" "placementcategory"
          "matchedplacementcategory" "matchedplacementcategory"
          "searchterm"        "searchterm"
          "matchedsearchterm" "matchedsearchterm"
          "walletid"          "walletname"
          "zoneid"            "zonename"}
         device-fields
         bid-modifier-fields))

(def report-name-fields
  "Maps from the value to the name fields in the report CSV."
  (merge report-name-fields-order
         product-fields))

(defn date-fields
  [report-time-period]
  (condp = report-time-period
    ;; See `report-field-titles`
    "hour" #{"start" "end"}
    "day" #{"start" "end"}
    "week" #{"start" "end"}
    "month" #{"start" "end"}
    "total" #{"start" "end"}
    #{}))

(defn report-time-period
  [report-meta]
  (get-in report-meta ["Request" "TimePeriod"]))
